import React, { useState, useEffect } from 'react';
import '../styles/Testimonials.css';

interface Testimonial {
  id: number;
  name: string;
  role: string;
  company?: string;
  image: string;
  rating: number;
  review: string;
  service: string;
  location: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Business Owner",
    company: "Kumar Industries",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    rating: 5,
    review: "WeLegal provided exceptional legal support for my property dispute. The transparent pricing and doorstep consultation made the entire process stress-free. Highly recommended!",
    service: "Civil Law",
    location: "Delhi"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Software Engineer",
    image: "https://images.unsplash.com/photo-1494790108755-2616b6d1c82b?w=150&h=150&fit=crop&crop=face",
    rating: 5,
    review: "The matrimonial law consultation was handled with great sensitivity and professionalism. The lawyer provided clear guidance throughout my divorce proceedings.",
    service: "Matrimonial Law",
    location: "Gurugram"
  },
  {
    id: 3,
    name: "Amit Singh",
    role: "Entrepreneur",
    company: "Tech Startup",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    rating: 5,
    review: "Quick and efficient service for my contract review. The virtual consultation was convenient and the lawyer was very knowledgeable about startup legal requirements.",
    service: "Contract Law",
    location: "Noida"
  },
  {
    id: 4,
    name: "Sunita Gupta",
    role: "Homemaker",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    rating: 5,
    review: "Excellent support for my cheque bounce case. The pricing was transparent and the outcome was favorable. Thank you WeLegal team!",
    service: "Negotiable Instruments",
    location: "Faridabad"
  }
];

const Testimonials: React.FC = () => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`fas fa-star ${index < rating ? 'filled' : ''}`}
      ></i>
    ));
  };

  return (
    <section className="testimonials">
      <div className="container">
        <div className="testimonials-header">
          <h2 className="section-title animate-fadeInUp">Happy Clients</h2>
          <p className="section-subtitle animate-fadeInUp">
            See what our satisfied clients say about WeLegal's professional legal services
          </p>
        </div>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id} 
              className="testimonial-card animate-fadeInUp"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="testimonial-content">
                <div className="rating">
                  {renderStars(testimonial.rating)}
                </div>
                <p className="review-text">"{testimonial.review}"</p>
                <div className="service-tag">
                  <i className="fas fa-tag"></i>
                  {testimonial.service}
                </div>
              </div>
              
              <div className="client-info">
                <div className="client-avatar">
                  <img src={testimonial.image} alt={testimonial.name} />
                </div>
                <div className="client-details">
                  <h4 className="client-name">{testimonial.name}</h4>
                  <p className="client-role">
                    {testimonial.role}
                    {testimonial.company && <span> at {testimonial.company}</span>}
                  </p>
                  <p className="client-location">
                    <i className="fas fa-map-marker-alt"></i>
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="testimonials-stats animate-fadeInUp">
          <div className="stat-item">
            <div className="stat-number">1000+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">4.9/5</div>
            <div className="stat-label">Average Rating</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">95%</div>
            <div className="stat-label">Success Rate</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">4 Cities</div>
            <div className="stat-label">Service Areas</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;